module.exports = __webpack_public_path__ + "static/media/12.dc994d93.mp3";